export default "__VITE_ASSET__LGtelTjC__"